<template>
  <Modal />
  <div class="grid-table-container">
    <div class="grid-table">
      <TopBar />
      <NavBar />
      <!-- <pre>{{ call_list }}</pre> -->
      <div class="bottom-margin"></div>
      <div>
        {{ settings.formatUIString(ui_string.answer_list_title_everyone, { 
          callee_name: callee_all ? 'Everyone' : callee_name, 
          caller_name: caller_all ? 'Everyone' : caller_name 
        }) }}
      </div>
      <template v-for="(call, index) in filteredAndIndexedCallList" :key="call.call_sid">
        <div v-if="call.answers.length > 0" class="grid-table-cell-wide row inlayed inlayed-top row-no-buttons"
          @click="() => navToViewCall(call.call_sid)">
          <div class="call-content">
            <div v-if="call.answers[0].ig_post_list.length > 0" class="image-column">
              <div class="image-stack">
                <img 
      :src="call.answers[0].ig_post_list[0].container_id"
      :alt="'Instagram Post'"
                  class="ig-post-image"
                  width="50"
                  height="50"
                  @error="event => event.target.src = 'https://placehold.co/50x50/orange/white?text=IG'"
                />
              </div>
            </div>

            <!-- Info Column -->
            <div class="question-subject">
              <span v-if="caller_all || callee_all" class="names">
                <template v-if="caller_all || callee_all">
                  {{ call.name_from }} to {{ call.name_to }}:
                </template>
                <template v-else-if="call.answers[0].ig_post_list.length > 0">
                  <template v-if="call.name_from !== caller_name">
                    {{ call.name_from }}:
                  </template>
                </template>
              </span>
              {{ call.question.question_subject }}
              <span class="indicators" v-if="call.answers[0].ig_post_list.some(post => !post.draft) || call.answers[0].ig_dm_list.length > 0">
                <template v-if="call.answers[0].ig_post_list.some(post => !post.draft)">P</template>
                <template v-if="call.answers[0].ig_post_list.some(post => !post.draft) && call.answers[0].ig_dm_list.length > 0">/</template>
                <template v-if="call.answers[0].ig_dm_list.length > 0">DM</template>
              </span>
              <div class="question-info">
                <span class="question-datetime">{{ formatCallDate(call.date_created) }}</span>
                <span class="question-duration">{{ formatDuration(call.answers[0].duration) }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="bottom-margin"></div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from 'pinia';
import { useSettingsStore } from "../store";
import axios from "axios";
import NavBar from "./NavBar.vue";
import TopBar from "./TopBar.vue";
import Modal from "./Modal.vue";

const router = useRouter();
const settings = useSettingsStore();
const { showModal, timezoneMap,caller_phone_number, timezone, BACK_URL, FRONT_URL, callee_phone_number, callee_id, caller_id, caller_all, callee_all, callee_name, caller_name, ui_string } = storeToRefs(settings);

const call_list = ref([]);



const formatCallDate = (dateString) => {
  const timeZone = timezoneMap[timezone.value] || "UTC";
  const options = {
    timeZone,
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  };
  const date = new Date(dateString);
  return date.toLocaleString("en-US", options)
    .replace(",", "")
    .replace(" AM", "a")
    .replace(" PM", "p");
};

const formatDuration = (duration) => {
  const minutes = Math.floor(duration / 60);
  const seconds = (duration % 60) - 1;
  return `${minutes}:${Math.max(0, seconds).toString().padStart(2, '0')}`;
};

const formatPhoneNumber = (phoneNumber) => {
  // Assuming the format is always +1 followed by 10 digits
  const match = phoneNumber.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNumber;
};


const filteredAndIndexedCallList = computed(() => {
  // Sort the filtered list by date_created from newest to oldest
  let sortedList = [...call_list.value].sort((a, b) => {
    const dateA = new Date(a.date_created);
    const dateB = new Date(b.date_created);
    return dateB - dateA; // Reverse the order
  });

  console.log(sortedList);

  // Calculate total number of calls
  const totalCalls = sortedList.length;

  // Map each call to include a displayIndex
  return sortedList.map((call, index) => ({ 
    ...call, 
    displayIndex: index + 1 // Start from 1 for the most recent call
  }));
});


const call_get_bycalleeid = async () => {
  showModal.value = true;
  try {
    let url = `${BACK_URL.value}/call/call_get_bycalleeid`;
    const payload = {
      callee_id: callee_id.value,
      caller_id: caller_id.value,
      caller_all: caller_all.value,
      callee_all: callee_all.value
    };
    const response = await axios.post(url, payload);
    call_list.value = response.data;
    
    // Extract question IDs and store them in the global store
    const questionIds = call_list.value.map(call => call.question.id);
  } catch (error) {
    if (error.response) {
      console.error(`HTTP error! status: ${error.response.status}`);
    } else {
      console.error(`An error occurred: ${error}`);
    }
  } finally {
    showModal.value = false;
  }
};

const navToViewCall = (call_sid) => {
  router.push(`/call_history/${call_sid}`);
};

onMounted(async () => {
  await settings.fetchSettings();
  await call_get_bycalleeid();
  window.scrollTo(0, 0);
});

watch([callee_id, caller_all, callee_all], async () => {
  await call_get_bycalleeid();
});
</script>
<style scoped>
.question-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}

.question-datetime {
  color: #45818e;
  /* font-size: 0.9em; */
}

.question-duration {
  color: #45818e;
  /* font-size: 0.9em; */
}

.grid-table-cell-wide .question-subject {
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}

.call-content {
  display: flex;
  gap: 15px;
  width: 100%;
}

.image-column {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
}

.ig-post-image {
  border-radius: 4px;
}

.indicators {
  color: orange;
  position: absolute;
  right: 0;
  top: 0;
}

.names {
  color: #666;
  margin-right: 5px;
}
</style>
